// extracted by mini-css-extract-plugin
export var title = "styles-module--title--30838";
export var wrapper = "styles-module--wrapper--1e4cf";